import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { FormikProps } from "formik";
import { TypeUser } from "src/interface/enum/TypeUser";
import ServiceForm from "./service-form";
import ServiceItem from "./serviceItem";
import { ServiceItemType } from "src/interface/enum/ServiceItemType";
import { IServiceItem } from "src/interface/IServiceItem";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabService({
  formik,
  serviceItems,
  setServiceItems,
}: {
  formik: FormikProps<any>;
  serviceItems: IServiceItem[];
  setServiceItems: (serviceItems: IServiceItem[]) => void;
}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="مشخصات خدمت" {...a11yProps(0)} />

          <Tab label="نوع" {...a11yProps(1)} />

          <Tab label="حجم" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <ServiceForm formik={formik} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ServiceItem
          serviceItemType={ServiceItemType.Type}
          setRows={setServiceItems}
          rows={serviceItems}
          key={"type"}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ServiceItem
          serviceItemType={ServiceItemType.Volume}
          setRows={setServiceItems}
          rows={serviceItems}
          key={"volume"}
        />
      </CustomTabPanel>
    </Box>
  );
}
